import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import MuiSwitch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { useAdminAuth } from "context/context";
const Switch = ({ checked, onChange, type, role }) => {
  const { roles } = useAdminAuth();

  const IOSSwitch = styled((props) => (
    <MuiSwitch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#DD5D59",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <>
      {type === "acl" &&
        (roles.includes(role) ? (
          <FormControlLabel
            className="m-0"
            checked={checked}
            onChange={onChange}
            control={<IOSSwitch />}
          />
        ) : (
          <FormControlLabel
            className="m-0"
            checked={checked}
            onChange={onChange}
            control={<IOSSwitch />}
            disabled={true}
          />
        ))}

      {type !== "acl" && (
        <FormControlLabel
          className="m-0"
          checked={checked}
          onChange={onChange}
          control={<IOSSwitch />}
        />
      )}
    </>
  );
};

export default Switch;
